const teacherinfo = {
    "hk":{
      "Fernando Linn":{
        "name":"Fernando Linn",
        "profile":"Fernando Linn is currently employed as a Hong Kong Education Bureau teacher. His credentials include a BA in History from the University of Arizona and an MA in Cultural Studies from the University of Hong Kong. Mr. Linn directs and coaches students in ESL Drama for a variety of plays and competitions. He has earned two Outstanding Director Awards at the Hong Kong Drama Festival.",
      },
    
    },
    "ml":{
      "Vaishnavi Gunasagaran":{
        "name":"Vaishnavi Gunasagaran",
        "profile":"Vaishnavi Gunasagaran is an experienced educator from Malacca, Malaysia, with a strong academic foundation in TESL. She holds a Bachelor of Education (TESL) from Victoria University of Wellington (2012) and a Master of Education (TESL), completed in 2021. With 12 years of formal teaching experience, Vaishnavi is also a dedicated contributor to student development beyond the classroom. She has served as a state-level technical officer for Public Speaking, as well as a district and state-level adjudicator for both Public Speaking and Debate competitions. Her commitment to language education and co-curricular excellence reflects her passion for nurturing confident, articulate learners."
    
      },
      "Karen Ma Sieng Shin":{
        "name":"Karen Ma Sieng Shin",
        "profile":"With over 12 years of experience in English language education, I currently serve as an English teacher at SJK(C) Chung Hua Miri, Sarawak. Passionate about literature and the performing arts, I have led the school’s poetry recitation team with dedication and creativity. In 2024, I was honoured with the Outstanding Tutor Award, and my team achieved both an international gold award and championship title. I believe in nurturing confidence, expression, and a love for language through performance and meaningful learning experiences.",
    
      }
    
      
    },
    "in":{
    

    },
    "sa":{
     
     
    },
    "th":{
    
       }
  }

  export default teacherinfo;